import { every, isNil, last } from 'lodash';

export namespace DragAndDrop {
  export type AnswerValue = { answers: Record<string, string | undefined> };
  export interface Answer {
    values: AnswerValue[];
    modifiedAt: number;
  }

  export type AnswerResult = {
    type: 'correct' | 'incorrect';
    correctValues: Record<string, boolean>;
  };

  // also edit isCorrectAnswer after change
  export type CorrectAnswer = Record<string, string[]>;

  export namespace Answer {
    export function isDone(answer: Answer | undefined): boolean {
      return answer ? !isNil(latestAnswer(answer)) : false;
    }

    export function latestAnswer(answer: Answer | undefined): AnswerValue | undefined {
      return last(answer && answer.values);
    }

    function dropZoneIsCorrect(
      dragItemId: string,
      dropzoneId: string | undefined,
      correctAnswers: string[],
      correctValues: Record<string, boolean>
    ): boolean {
      let placedCorrectly = true;
      if (correctAnswers.length === 0) {
        if (!dropzoneId) {
          correctValues[dragItemId] = true;
          placedCorrectly = true;
        } else {
          correctValues[dragItemId] = false;
          placedCorrectly = false;
        }
      } else {
        if (!dropzoneId) {
          correctValues[dragItemId] = false;
          placedCorrectly = false;
        } else {
          //DropzoneIds is the student answer and is always an array of length 1
          if (correctAnswers.includes(dropzoneId)) {
            correctValues[dragItemId] = true;
            placedCorrectly = true;
          } else {
            correctValues[dragItemId] = false;
            placedCorrectly = false;
          }
        }
      }
      return placedCorrectly;
    }

    export function resultForAnswer(answer: Answer | undefined, correctAnswers: CorrectAnswer): AnswerResult {
      const latest = latestAnswer(answer);
      if (!latest) return { type: 'incorrect', correctValues: { all: false } };
      const correctValues: Record<string, boolean> = {};
      let hasIncorrect = false;
      for (const [dragItemId, dropzoneId] of Object.entries(latest.answers)) {
        if (!dropZoneIsCorrect(dragItemId, dropzoneId, correctAnswers[dragItemId], correctValues)) hasIncorrect = true;
      }
      return { type: hasIncorrect ? 'incorrect' : 'correct', correctValues: correctValues };
    }
  }
}
